export default "__VITE_ASSET__WOxNZOer__"